module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-contractsView_depositExpiredErrorTitle',
        errorBody: 'contractsView-contractsView_depositExpiredErrorMessage',
        backButtonLabel: 'contractSummary-backToDeposits',
        backButtonLink: '/myprofile/deposits'
    },
}
